import { render, staticRenderFns } from "./extensions.vue?vue&type=template&id=2f122fc1"
import script from "./extensions.vue?vue&type=script&lang=ts"
export * from "./extensions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports